module["exports"] = [
  "شمال",
  "شرق",
  "غرب",
  "جنوب",
  "جدید",
  "جزیره"
];
